type ShopifyBillingRequiredPanelProps = {
  installedAppUrl?: string | null;
  shopifyAdminAppUrl?: string | null;
};

function openTopLevel(url?: string | null) {
  if (!url) return;

  try {
    if (window.top) {
      window.top.location.assign(url);
      return;
    }
  } catch {
    // Fall back below.
  }

  window.location.assign(url);
}

export default function ShopifyBillingRequiredPanel({
  installedAppUrl,
  shopifyAdminAppUrl,
}: ShopifyBillingRequiredPanelProps) {
  const appSettingsUrl = shopifyAdminAppUrl || installedAppUrl;

  return (
    <div className="rounded-2xl bg-white p-5 ring-1 ring-black/5">
      <div className="space-y-2">
        <h2 className="text-[15px] font-semibold text-gray-700">
          Choose a Shopify plan to continue
        </h2>

        <p className="text-[13px] font-normal text-gray-700">
          Sync is off until you choose a plan in Shopify.
        </p>

        <p className="text-[13px] text-gray-500">
          In Shopify: Nimos Connect → View details → Billing → Manage.
        </p>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        {appSettingsUrl ? (
          <button
            type="button"
            onClick={() => openTopLevel(appSettingsUrl)}
            className="h-10 rounded-xl bg-appleblue px-4 text-[13px] font-medium text-white hover:bg-appleblueD active:scale-95"
          >
            Open Shopify
          </button>
        ) : null}
      </div>
    </div>
  );
}
